import React, {Component} from 'react';
import { Link } from "react-router";
import PropTypes from 'prop-types';
import { database, auth } from '../firebase';
import Report from './Report';
var randomstring = require("randomstring");
var { version } = require("../project.json");

class Menu extends Component {
  constructor(props) {
    super(props);
    this.menuId = randomstring.generate(20);
    this.opened = props.opened;
    this.state = {
      opened: this.opened,
      open: false
    }
    this.yap = this.yap.bind(this);
    this.aç = this.aç.bind(this);
    this.kapat = this.kapat.bind(this);
  }

  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      if (user === null) return;

      document.getElementById("gk").style.display = "none";
      
      database.ref("users/" + user.uid).get().then(snap => {
        if (snap.val().verified !== undefined) {
          document.getElementById("item-taslaklarım").style.display = "block";
        }
      })
    })
  }

  yap() {
    this.setState({open: true});
  }

  aç() {
    document.getElementById(this.menuId+"menu-div").style.top = "0%";
  }

  kapat() {
    document.getElementById(this.menuId+"menu-div").style.top = "100%";
  }

  render() {
    if (document.getElementById(this.menuId+"menu-div")) {
      if (this.props.opened == true) this.aç();
      else this.kapat()
    }
    return (
    <div style={this.state.opened == false ? {top: "100%"} : {top: "0"}}>
      <div className="menu" id={this.menuId+"menu-div"}>
        <div>
          <img src="/çarpı-light.png" className="çık" onClick={this.kapat}/>
          <b>MENÜ</b>
        </div>
        <ul>
          <Link to="/yazarlar"><li>Yazarlar</li></Link>
          <Link to="/taslaklar" id="item-taslaklarım" style={{display: "none"}}><li>Taslaklarım</li></Link>
          <li id="gk"><Link to="/giris-yap">Giriş Yap</Link> veya <Link to="/kayit-ol" style={{marginRight: "15px"}}>Kaydol</Link></li>
          <Link to="/sss"><li>Sık Sorulan Sorular</li></Link>
          <Link to="/surum-notlari"><li>Sürüm Notları</li></Link>
          <a onClick={this.yap} style={{display: "none"}}><li>Geri Bildirim Gönder</li></a>
        </ul>

        <div style={{width: "max-content", margin: "auto", color: "#ebebeb", fontSize: "16px"}}>
          TALEFORCE <br/> 
          <div style={{color: "#ccc", fontSize: "12px", textAlign: "center"}}>v.{version}</div>
        </div>
      </div>
      
      <Report opened={this.state.open}/>

      <style>{`
        .menu {
          top: 100%;
          margin-top: -150px;
          left: 50%;
          margin-left: -200px;
          color: #fff;
          background: #2f2d33;
          width: 400px;
          height: 220px;
          opacity: 1;
          z-index: 999;
          position: fixed;
          padding: 20px 10px;
          transition: .2s;
          display: none;
        }

        .menu a {
          color: #F57029;
        }

        .menu b {
          width: 100%;
          position: absolute;
          font-size: 20px;
          font-weight: normal;
          line-height: 32px;
          right: 0;
          opacity: .8;
          text-align: center;
        }

        .menu ul {
          padding: 0;
        }

        .menu li {
          list-style-type: none;
          padding: 10px 0;
          padding-left: 10px;
          border-top: 1px solid #bfbfbf45;
          color: #fff;
        }

        .çık {
          width: 32px;
          height: 32px;
          margin-left: 10px;
          visibility: hidden;
        }

        @media (max-width: 900px) {
          .menu {
            width: 100%;
            max-width: 300px;
            height: 100%;
            left: inherit;
            right: 0;
            padding: 10px 0px;
            margin: 0;
            z-index: 15;
            display: block;
          }
        }

        @media (max-width: 623px) {
          .menu {
            width: 100%;
            max-width: inherit;
            height: 100%;
            left: 0;
            padding: 10px 0px;
            margin: 0;
            z-index: 15;
            display: block;
          }
        }
      `}</style>
    </div>
  )}
}

Menu.propTypes = {
  opened: PropTypes.bool,
}
export default Menu;